<template>
    <div class="nav">

            <el-menu :default-active="activeIndex2" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            background-color="#28439E" text-color="#fff" active-text-color="#ffd04b">
            <el-submenu index="1">
                <template slot="title">
                    <div style="font-family: PingFangSC, PingFang SC;letter-spacing: 4px;font-size: 28px;color:#FFDAB4;display: flex;align-items: center;justify-content: center;flex-direction: column; height: 71px;"
                        @click="wl"><span style="line-height: 25px;">齐来崇拜</span></div>
                </template>
                <!-- <el-menu-item index="1-1" >齐来崇拜</el-menu-item> -->
                <el-menu-item index="1-2" style="padding-left: 30px;"><a
                        href="http://live.jnccljh.com/ms/post579/msg-file29937e08479845e0c202419762c8630d.html"
                        target="_blank">直播入口</a></el-menu-item>
                <el-menu-item index="1-3" style="padding-left: 30px;" @click="jh">聚会时间</el-menu-item>
                <el-menu-item index="1-4" style="padding-left: 30px;" @click="xz">APP下载</el-menu-item>

            </el-submenu>
            <el-submenu index="2">
                <template slot="title">
                    <div style="font-family: PingFangSC, PingFang SC;letter-spacing: 4px;font-size: 28px;color:#FFDAB4;display: flex;align-items: center;justify-content: center;flex-direction: column; height: 71px;"
                        @click="xy"><span style="line-height: 25px;">信仰之门</span></div>
                </template>
                <!-- <el-menu-item index="2-1" @click="xy">信仰之门</el-menu-item> -->
                <el-menu-item index="2-2" @click="sjxs" style="padding-left: 30px;">圣剧欣赏</el-menu-item>
                <el-menu-item index="2-3" @click="mejz" style="padding-left: 30px;">圣诗赞美</el-menu-item>
                <el-menu-item index="2-4" @click="xyjj" style="padding-left: 30px;">福音信息</el-menu-item>
                <el-menu-item index="2-5" @click="jtjj" style="padding-left: 30px;">生命之道</el-menu-item>
            </el-submenu>
            <el-submenu index="3">
                <template slot="title">
                    <div style="font-family: PingFangSC, PingFang SC;letter-spacing: 4px;font-size: 28px;color:#FFDAB4;display: flex;align-items: center;justify-content: center;flex-direction: column; height: 71px;"
                        @click="sm"><span style="line-height: 25px;">生命之粮</span> </div>
                </template>
                <!-- <el-menu-item index="3-0" @click="sm">生命之粮</el-menu-item> -->
                <el-menu-item index="3-1" @click="zdzt" style="padding-left: 30px;">日常证道</el-menu-item>
                <el-menu-item index="3-2" @click="jzzt" style="padding-left: 30px;">查经系列</el-menu-item>
                <el-menu-item index="3-3" @click="zmzt" style="padding-left: 30px;">专题证道</el-menu-item>
                <el-menu-item index="3-3" @click="zlxz" style="padding-left: 30px;">资料专区</el-menu-item>
            </el-submenu>
            <el-submenu index="4">
                <template slot="title">
                    <div style="font-family: PingFangSC, PingFang SC;letter-spacing: 4px;font-size: 28px;color:#FFDAB4;display: flex;align-items: center;justify-content: center;flex-direction: column; height: 71px;"
                        @click="tq"><span style="line-height: 25px;">团契之家</span> </div>
                </template>
                <!-- <el-menu-item index="4-1" @click="tq">团契之家</el-menu-item> -->
                <el-menu-item index="4-2" @click="sgjj" style="padding-left: 30px;">生命见证</el-menu-item>
                <el-menu-item index="4-3" @click="tqjj" style="padding-left: 30px;">事工团契</el-menu-item>

            </el-submenu>
        </el-menu>


    </div>
</template>

<script>
export default {
    data() {
        return {
            activeIndex2: '1'
        }
    },
    methods: {
        tq() {
            this.$router.push({ path: "/tq", })
        },
        sm() {
            this.$router.push({ path: "/sm" })
        },
        xy() {
            this.$router.push({ path: "/xy" })
        },
        wl() {
            this.$router.push({ path: "/wl" })
        },
        jh() {
            this.$router.push({ path: "/time" })
        },
        xz() {
            this.$router.push({ path: "/Download" })
        },
        sjxs() {
            this.$router.push({ path: "/sjxs" })
        },
        mejz() {
            this.$router.push({ path: "/mejz" })
        },
        xyjj() {
            this.$router.push({ path: "/xyjj" })
        },
        jtjj() {
            this.$router.push({ path: "/jtjj" })
        },
        zdzt() {
            this.$router.push({ path: "/zdzt" })
        },
        yzlh() {
            this.$router.push({ path: "/yzlh" })
        },
        jzzt() {
            this.$router.push({ path: "/jzzt" })
        },
        zmzt() {
            this.$router.push({ path: "/zmzt" })
        },
        zlxz() {
            this.$router.push({ path: "/zlxz" })
        },
        sgjj(item) {
            this.$router.push({ path: "/sgjj", query: { id: item } })
        },
        tqjj(item) {
            this.$router.push({ path: "/tqjj", query: { id: item } })
        },
        handleSelect(key, keyPath) {
            console.log(key, keyPath);
        }
    }
}
</script>

<style scoped>
.nav {
    width: 100%;
    /* height: 71px; */
    background-color: #28439E;
    display: flex;
    justify-content: center;

    position: relative;
    height: 71px;

}

.b {
    width: 70%;
    height: 71px;
    margin: 0 auto;
    display: flex;

}

.c {
    width: 24%;
    height: 71px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #FFDAB4;
    font-style: normal;
}

.c:hover {
    background-color: #1463FF;
    width: 24%;
    height: 71px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #fff;
    font-style: normal;
}

.el-menu {
    width: 70%;

    display: flex;
    justify-content: space-around;
}

.el-submenu__title {
    display: flex;
    align-items: center;
}

.el-submenu {
    width: 20%;
    display: flex;
    height: 71px;
    justify-content: center;
}
.el-icon-arrow-down::before {
    content: "";
}
a {
    text-decoration: none;
    color: white;
}

a:link {
    color: white;

}

.el-menu-item {
    width: 100%;
    background-color: #fff;
}

a,
a:hover,
a:active,
a:visited,
a:link,
a:focus {
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
    -webkit-tap-highlight-color: transparent;
    outline: none;
    background: none;
    text-decoration: none;
}

.el-submenu__icon-arrow {
    display: none;
}

.el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
    display: none;

}

.el-submenu>.el-submenu__title .el-submenu__icon-arrow {
    display: none;

}
.el-submenu__icon-arrow {

position: absolute;

top: 50%;

right: 92px !important;

margin-top: -7px;

transition: transform .3s;

font-size: 12px;

}
</style>



// WEBPACK FOOTER //
// src/components/navs.vue